import { toast } from "react-toastify";

const SEND_URL = /\/negocio\/(notify|accounts\/\d+\/notify-update|reminders\/dispatch)(\?|$)/;

const inflight = new Map();

const keyOf = (config) => {
  const body = typeof config.data === "string" ? config.data : JSON.stringify(config.data || {});
  return `${String(config.method || "").toUpperCase()} ${config.url} ${body}`;
};

const finish = (config) => {
  const meta = config && config.__sendGuard;
  if (!meta) return;
  inflight.delete(meta.key);
  toast.dismiss(meta.toastId);
};

/**
 * Envíos de mensajes a clientes (WhatsApp/Telegram): aviso inmediato "Enviando…" y
 * un mismo envío repetido mientras el primero sigue en curso reutiliza esa petición.
 */
export default function installSendGuard(api) {
  api.interceptors.request.use((config) => {
    if (config.__sendGuard) return config;
    if (String(config.method || "").toLowerCase() !== "post" || !SEND_URL.test(String(config.url || ""))) {
      return config;
    }
    const key = keyOf(config);
    const running = inflight.get(key);
    if (running) {
      toast.info("Ese mensaje ya se está enviando…", { toastId: `dup-${key}`, autoClose: 2500 });
      return { ...config, adapter: () => running };
    }
    const toastId = toast.info("Enviando mensaje…", { autoClose: false, closeOnClick: false });
    let resolveRun;
    let rejectRun;
    const run = new Promise((resolve, reject) => {
      resolveRun = resolve;
      rejectRun = reject;
    });
    run.catch(() => {});
    inflight.set(key, run);
    config.__sendGuard = { key, toastId, resolveRun, rejectRun };
    return config;
  });

  api.interceptors.response.use(
    (response) => {
      const meta = response.config && response.config.__sendGuard;
      if (meta) {
        meta.resolveRun(response);
        finish(response.config);
      }
      return response;
    },
    (error) => {
      const meta = error && error.config && error.config.__sendGuard;
      if (meta) {
        meta.rejectRun(error);
        finish(error.config);
      }
      return Promise.reject(error);
    }
  );
}
